import { Sidebar } from '@/components/sidebar/Sidebar';
import { cn } from '@/lib/utils';

import { Navbar } from '../navbar/Navbar';

interface SidebarLayoutProps {
  children: React.ReactNode;
  isSuperUser?: boolean;
}

export const SidebarLayout = ({
  children,
  isSuperUser,
}: SidebarLayoutProps): JSX.Element => {
  return (
    <>
      <Sidebar />
      <main
        className={cn(
          'min-h-[calc(100vh_-_56px)] bg-zinc-50 dark:bg-zinc-900',
          'lg:ml-48',
          'lg:w-[calc(100%-12rem)]',
          'transition-[margin-left] ease-in-out duration-300',
        )}
      >
        <Navbar isSuperUser={isSuperUser ?? false} />
        <div
          className={cn(
            'h-full scroll-container max-w-full pt-6 px-12',
            isSuperUser === true ? 'pb-28' : 'pb-14',
          )}
        >
          {children}
        </div>
      </main>
      <footer
        className={cn(
          'transition-[margin-left] ease-in-out duration-300',
          'lg:ml-72',
        )}
      >
        <div className="w-full bg-background/95 shadow backdrop-blur supports-[backdrop-filter]:bg-background/60">
          <div className="mx-4 md:mx-8 flex h-14 items-center"></div>
        </div>
      </footer>
    </>
  );
};
